import React from "react";
import arrowRightIcon from "../assets/images/arrow-right-big.svg";
import findPestIcon from "../assets/images/ax-find-pest.svg";
import monitorIcon from "../assets/images/ax-monitor.svg";
import locationMarkerIcon from "../assets/images/solid-map-marker-alt.svg";
import { LinkInfo } from "../models/shared/LinkInfo";
import { isNullOrWhiteSpace, replaceWithUnicode } from "../shared/string";
import { iconsList } from "../utilities/iconsList";
import CardList from "./CardList";
import SanityLink from "./SanityLink";

type CardListItem = LinkInfo & {
  svgBgColor: string;
  svg: JSX.Element;
};

export interface WhatsYourSituationProps {
  title?: string;
  subtitle?: string;
  card1?: CardListItem;
  card2?: CardListItem;
  card3?: CardListItem;
  icon3?: string;
}

const WhatsYourSituation = (props: WhatsYourSituationProps) => {
  const { title, subtitle, card1, card2, card3, icon3 } = props;

  const cards: CardListItem[] = [];
  if (card1) {
    card1.svgBgColor = "bg-brand-tertiary-70";
    card1.svg = <use xlinkHref={monitorIcon.url} />;
    cards.push(card1);
  }
  if (card2) {
    card2.svg = <use xlinkHref={findPestIcon.url} />;
    card2.svgBgColor = "bg-brand-secondary-50";
    cards.push(card2);
  }
  if (card3) {
    if (!isNullOrWhiteSpace(icon3)) {
      card3.svg = <use xlinkHref={iconsList[icon3]} />;
    } else {
      card3.svg = <use xlinkHref={locationMarkerIcon.url} />;
    }

    card3.svgBgColor = "bg-brand-primary-80";
    cards.push(card3);
  }

  return (
    <CardList
      title={title}
      subtitle={subtitle}
      liClassName="border-none bg-brand-primary-20 hover:bg-brand-primary-30"
      gridBreakpointStyle={"column"}
    >
      {cards?.map((item, index) => (
        <SanityLink
          {...item}
          key={index}
          className="flex p-8 no-underline text-white h-full w-full outline-none rounded-lg transition-all duration-200 focus:shadow-outline"
        >
          <div className="flex flex-shrink-0 mr-6 items-center">
            {item.svg && (
              <div
                className={`flex justify-center items-center w-16 h-16 p-3 rounded-full ${item.svgBgColor}`}
              >
                <svg className="fill-current text-neutral-100 max-w-full max-h-full">
                  {item.svg}
                </svg>
              </div>
            )}
          </div>
          <div className="flex w-full justify-between items-center">
            <p className="text-xl font-bold text-white mb-0 mr-3 uppercase">
              {replaceWithUnicode(item.title)}
            </p>

            <div className="flex fill-current items-center flex-shrink-0 w-8 h-8">
              <svg className="max-w-full max-h-full">
                <use xlinkHref={arrowRightIcon.url} />
              </svg>
            </div>
          </div>
        </SanityLink>
      ))}
    </CardList>
  );
};

export default WhatsYourSituation;
